import { ref, watch } from 'vue'
import { onKeyStroke, useMediaQuery } from '@vueuse/core'

import type { Ref } from 'vue'

interface UseSidebarDrawerReturn {
  refIsDrawerOpen: Ref<boolean>
  setDrawer: (value: boolean) => void
}

/** Same width as `media_min_w_ipad_pro`: from here the sidebar is the fixed rail, not a drawer. */
const RAIL_MEDIA_QUERY = '(min-width: 1024px)'

/**
 * Open state of the off-canvas sidebar drawer used below 1024px. It closes on navigation, on Escape,
 * and when the viewport grows into the rail layout, so it can never stay open behind the rail.
 */
export const useSidebarDrawer = (): UseSidebarDrawerReturn => {
  const route = useRoute()
  const refIsRail = useMediaQuery(RAIL_MEDIA_QUERY)

  const refIsDrawerOpen = ref<boolean>(false)

  const setDrawer = (value: boolean): void => {
    refIsDrawerOpen.value = value
  }

  watch(() => route.fullPath, () => setDrawer(false))

  watch(refIsRail, (isRail) => {
    if (isRail) setDrawer(false)
  })

  onKeyStroke('Escape', () => setDrawer(false))

  return {
    refIsDrawerOpen,
    setDrawer,
  }
}
